import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { LoadingIndicator } from "ots-components-library";
// import { Link, useHistory } from "react-router-dom";
// import { useOktaAuth } from "@okta/okta-react";

import {
  fetchLocations,
  selectActiveLocation,
  selectAllDisplayLocations,
  selectFavoritedDisplayLocations,
  selectShowFavoritedLocations,
} from "../../redux/features/locationsSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  LocationDetailView,
  LocationsListView,
  LocationsMapView,
  SearchAndFilterLocations,
} from "../../components";

import "./Home.scss";
import { navHeightPixel } from "../../utils/stylingConsts";

/**
 * Home–the home page component
 * All pages are built on the using material-ui grid.
 * All sections are surrounded in a "pageContainer" with each section in a "pageBody"
 * see below for example or delete everything below the first "pageBody"
 */

function Home(): React.JSX.Element {
  const dispatch = useAppDispatch();

  const allDisplayLocations = useAppSelector(selectAllDisplayLocations);
  const favoritedDisplayLocations = useAppSelector(
    selectFavoritedDisplayLocations,
  );
  const showFavoritesOnly = useAppSelector(selectShowFavoritedLocations);
  const displayedLocations = showFavoritesOnly
    ? favoritedDisplayLocations
    : allDisplayLocations;

  const activeLocation = useAppSelector(selectActiveLocation);
  const loading = useAppSelector((state) => state.locations.loading);

  const [showHeaderShadow, setShowHeaderShadow] = useState(false);

  const onScrollHandler = (event: React.UIEvent<HTMLElement>) => {
    setShowHeaderShadow(!(event.currentTarget.scrollTop === 0));
  };

  const getBoxShadow = () => {
    if (showHeaderShadow) {
      return { boxShadow: 4 };
    }
    return {};
  };

  useEffect(() => {
    dispatch(fetchLocations());
    //dispatch(fetchFavoritesList());
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <Box
          display="flex"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <LoadingIndicator variant="page" />
        </Box>
      ) : (
        <Box
          display="flex"
          height={`calc(100% - ${navHeightPixel})`}
          overflow="hidden"
        >
          <Box
            width="400px"
            overflow="hidden"
            display="flex"
            flexDirection="column"
            sx={{ boxShadow: 3, zIndex: 999 }}
          >
            <SearchAndFilterLocations boxShadow={getBoxShadow} />
            <LocationsListView
              locations={displayedLocations}
              onScrollHandler={onScrollHandler}
            />
          </Box>

          <Box flexGrow={1} position="relative">
            <LocationsMapView locations={displayedLocations} />
            {activeLocation && <LocationDetailView location={activeLocation} />}
          </Box>
        </Box>
      )}
    </>
  );
}
export default Home;
